import { LegalEntitiesPeriodsService_legalEntityPeriodsVersionServiceGetPartnerships } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesPeriodsService_legalEntityPeriodsVersionServiceGetPartnerships'

export const useFetchPartnershipPeriods =
  LegalEntitiesPeriodsService_legalEntityPeriodsVersionServiceGetPartnerships.useSuspenseQuery
